import { lazyComponent } from '@/utils/lazyComponent'

// qz-tray·jsrsasign·jsbarcode 까지 붙는 화면이라 청크를 나눈다(반품작업_신규 2.0 RGR18 과 같다).
export default lazyComponent(() => import('./index'))
